"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgCar = function SvgCar(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M748.74 510.15c36.705 0 66.46 29.755 66.46 66.46s-29.755 66.46-66.46 66.46-66.46-29.755-66.46-66.46 29.755-66.46 66.46-66.46zm-472.58 0c36.705 0 66.46 29.755 66.46 66.46s-29.755 66.46-66.46 66.46-66.46-29.755-66.46-66.46 29.755-66.46 66.46-66.46zm714.82-123.99h-68.71l-36.05-152c-13.5-56.65-62.37-96.2-118.84-96.2H257.52c-56.47 0-105.34 39.55-118.78 96.2l-36.05 152H33.98c-18.75 0-34 14.91-34 33.23v62c0 18.32 15.23 33.23 34 33.23H63.8v214.86c0 17.68 14.1 32.14 31.91 33.18v90.86c0 18.34 15.23 33.22 33.95 33.22h127.6c18.75 0 34-14.88 34-33.22v-90.81h442.43v90.81c0 18.34 15.23 33.22 34 33.22h127.6c18.75 0 34-14.88 34-33.22v-90.86c17.77-1 31.85-15.52 31.85-33.18V514.59h29.88c18.69 0 33.92-14.91 33.92-33.23v-62c-.04-18.33-15.27-33.2-33.96-33.2zm-818.58 0l32.5-136.94c6.26-26.36 27.89-44.76 52.61-44.76h509.87c24.69 0 46.32 18.4 52.55 44.76l32.6 136.94H172.4zm720.8 66.46v243.64H131.73V452.58l761.47.04z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgCar, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;